import { useCallback, useEffect, useRef, useState } from "react";
import "./Gradient.scss";

export function Gradient() {
	const ref = useRef();
	const [size, setSize] = useState(0);

	const scale = 3;

	const updateDimensions = useCallback(() => {
		const { innerWidth: w, innerHeight: h } = window;
		setSize(w >= h ? w : h);
	}, []);

	useEffect(() => {
		updateDimensions();

		ref.current.style.animation = "translate-gradient 8s infinite linear"; // add animation here, as otherwise keyframes are incorrect in Safari
	}, [updateDimensions]);

	return (
		<div
			className="gradient"
			ref={ref}
			style={{
				"backgroundSize": `${scale * size}px ${scale * size}px`,
				"--background-translate": `0% ${-scale * size}px`,
			}}></div>
	);
}
